{
  "familyId": "TIJD-SAMENGESTELD",
  "questions": [
    {
      "id": "TIJD-SAMENGESTELD-001",
      "familyId": "TIJD-SAMENGESTELD",
      "module": "Tijd",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_samengesteld",
      "questionType": "multiple_choice",
      "question": "Hoeveel minuten zijn 2 uur en 15 minuten samen?",
      "options": ["135 minuten", "215 minuten", "120 minuten", "75 minuten"],
      "correctAnswer": 0,
      "conceptId": "time_hours_minutes_to_minutes",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "Uren en minuten omrekenen",
            "content": "Reken de uren eerst om naar minuten: 1 uur = 60 minuten. Dus 2 uur = 2 × 60 = 120 minuten. Tel dan de losse minuten erbij: 120 + 15 = 135 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Je wilt 2 uur en 15 minuten omrekenen naar alleen minuten. Stap 1: Reken de uren om. 1 uur = 60 minuten, dus 2 uur = 2 × 60 = 120 minuten. Stap 2: Tel de losse minuten erbij. 120 + 15 = 135 minuten. Controleer: 135 ÷ 60 = 2 uur en 15 minuten ✓.",
        "solutionSteps": [
          "Reken de uren om: 2 uur = 2 × 60 = 120 minuten",
          "Tel de losse minuten erbij: 120 + 15 = 135 minuten",
          "Controleer: 135 ÷ 60 = 2 rest 15 → 2 uur 15 min ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 2 × 60 = 120 minuten, plus 15 = 135 minuten.",
          "1": "Je hebt de getallen 2, 1 en 5 achter elkaar gezet (215) in plaats van te rekenen. Reken altijd stap voor stap: 2 uur = 120 minuten, dan + 15 = 135.",
          "2": "120 minuten is alleen de 2 uur. Je bent de 15 losse minuten vergeten op te tellen: 120 + 15 = 135 minuten.",
          "3": "Je hebt waarschijnlijk 60 + 15 = 75 gedaan (1 uur + 15 minuten). Maar het gaat om 2 uur: 2 × 60 = 120, dan + 15 = 135."
        }
      }
    },
    {
      "id": "TIJD-SAMENGESTELD-002",
      "familyId": "TIJD-SAMENGESTELD",
      "module": "Tijd",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_samengesteld",
      "questionType": "multiple_choice",
      "question": "Een film duurt 1 uur en 45 minuten. De film begint om 14:30. Hoe laat is de film afgelopen?",
      "options": ["16:15", "15:75", "16:45", "15:15"],
      "correctAnswer": 0,
      "conceptId": "time_end_time_calculation",
      "variantIndex": 2,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.74,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "Eindtijd berekenen",
            "content": "Tel de tijd stap voor stap op. 14:30 + 1 uur = 15:30. Dan + 45 minuten: 30 + 45 = 75 minuten. 75 minuten = 1 uur en 15 minuten. Dus: 15:30 + 1 uur 15 min = 16:15. Let op: als de minuten boven 60 komen, zit er een extra uur in!",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De film begint om 14:30 en duurt 1 uur en 45 minuten. Tel stap voor stap op. Stap 1: 14:30 + 1 uur = 15:30. Stap 2: 15:30 + 45 minuten. De minuten: 30 + 45 = 75 minuten. Dat is meer dan 60, dus er zit een extra uur in: 75 − 60 = 15 minuten over, plus 1 extra uur. Stap 3: 15 uur + 1 = 16 uur, en 15 minuten. Antwoord: 16:15.",
        "solutionSteps": [
          "Begintijd: 14:30, duur: 1 uur 45 min",
          "14:30 + 1 uur = 15:30",
          "15:30 + 45 min → minuten: 30 + 45 = 75",
          "75 min = 1 uur en 15 min → 16:15"
        ],
        "distractorExplanations": {
          "0": "Goed! 14:30 + 1 uur = 15:30, dan + 45 minuten = 16:15.",
          "1": "15:75 bestaat niet als kloktijd! Je hebt 30 + 45 = 75 minuten goed opgeteld, maar vergeten dat 75 minuten = 1 uur en 15 minuten is. Trek 60 af van de minuten en tel 1 uur op: 15:75 → 16:15.",
          "2": "Je hebt waarschijnlijk 14 + 1 = 15 uur en dan de minuten fout berekend. 30 + 45 = 75 minuten, niet 45. En 75 minuten = 1 uur en 15 minuten, dus het uur wordt 16 en de minuten worden 15.",
          "3": "Je hebt de uren correct opgeteld (14 + 1 = 15) maar de minuten fout: 30 + 45 = 75, niet 15. Zet 75 minuten om naar 1 uur en 15 minuten, zodat het totaal 16:15 wordt."
        }
      }
    },
    {
      "id": "TIJD-SAMENGESTELD-003",
      "familyId": "TIJD-SAMENGESTELD",
      "module": "Tijd",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_samengesteld",
      "questionType": "multiple_choice",
      "question": "Een trein vertrekt om 09:45 en komt aan om 12:20. Hoe lang duurt de reis?",
      "options": ["2 uur en 35 minuten", "3 uur en 25 minuten", "2 uur en 25 minuten", "3 uur en 35 minuten"],
      "correctAnswer": 0,
      "conceptId": "time_duration_calculation",
      "variantIndex": 3,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.76,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "Stappenmethode voor tijdsduur",
            "content": "Reken in stappen van vertrektijd naar aankomsttijd. Van 09:45 → 10:00 = 15 min. Van 10:00 → 12:00 = 2 uur. Van 12:00 → 12:20 = 20 min. Totaal: 2 uur + 15 + 20 = 2 uur 35 min.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Gebruik de stappenmethode om de tijdsduur te berekenen. Stap 1: Van 09:45 naar 10:00 = 15 minuten. Stap 2: Van 10:00 naar 12:00 = 2 uur. Stap 3: Van 12:00 naar 12:20 = 20 minuten. Stap 4: Tel alles op: 2 uur + 15 min + 20 min = 2 uur en 35 minuten.",
        "solutionSteps": [
          "09:45 → 10:00 = 15 minuten",
          "10:00 → 12:00 = 2 uur",
          "12:00 → 12:20 = 20 minuten",
          "Totaal: 2 uur + 15 + 20 = 2 uur 35 min"
        ],
        "distractorExplanations": {
          "0": "Goed! 09:45 → 10:00 (15 min) → 12:00 (2 uur) → 12:20 (20 min) = 2 uur en 35 minuten.",
          "1": "Je hebt waarschijnlijk 12 − 9 = 3 uur gerekend. Maar je vertrekt om 09:45, niet om 09:00. Die 45 minuten moet je verrekenen. Gebruik de stappenmethode: 09:45 → 10:00 (15 min) → 12:20 (2 uur 20 min) = 2 uur 35 min.",
          "2": "Bijna! Je mist 10 minuten. Controleer: 15 minuten (naar 10:00) + 2 uur (naar 12:00) + 20 minuten (naar 12:20) = 2 uur en 35 minuten, niet 25.",
          "3": "Je hebt waarschijnlijk 12 − 9 = 3 uur genomen, maar dat klopt niet want je vertrekt om 09:45, niet om 09:00. Gebruik de stappenmethode voor nauwkeurigheid."
        }
      }
    },
    {
      "id": "TIJD-SAMENGESTELD-004",
      "familyId": "TIJD-SAMENGESTELD",
      "module": "Tijd",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_samengesteld",
      "questionType": "multiple_choice",
      "question": "Lisa werkt van 08:15 tot 12:30 en van 13:15 tot 17:00. Hoeveel uur en minuten werkt ze in totaal?",
      "options": ["8 uur", "8 uur en 30 minuten", "7 uur en 30 minuten", "9 uur"],
      "correctAnswer": 0,
      "conceptId": "time_total_work_hours",
      "variantIndex": 4,
      "citoDifficulty": 0.65,
      "citoDiscrimination": 0.80,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "Twee periodes optellen",
            "content": "Bereken elke periode apart. Ochtend: 08:15 → 12:30 = 4 uur 15 min. Middag: 13:15 → 17:00 = 3 uur 45 min. Tel op: 4u15 + 3u45 = 7u60 = 8 uur. Let op: de pauze (12:30-13:15) telt niet mee!",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Lisa werkt in twee shifts. Bereken elke shift apart. Ochtendshift: van 08:15 tot 12:30. Gebruik de stappenmethode: 08:15 → 12:15 = 4 uur, dan 12:15 → 12:30 = 15 min. Totaal: 4 uur 15 min. Middagshift: van 13:15 tot 17:00. 13:15 → 17:15 = 4 uur, maar het is 17:00, dus 4 uur − 15 min = 3 uur 45 min. Tel de shifts op: 4 uur 15 min + 3 uur 45 min = 7 uur 60 min = 8 uur precies. Let op: de pauze (12:30 tot 13:15 = 45 min) telt niet mee als werktijd.",
        "solutionSteps": [
          "Ochtend: 08:15 → 12:30 = 4 uur 15 min",
          "Middag: 13:15 → 17:00 = 3 uur 45 min",
          "Optellen: 4u15 + 3u45 = 7u60",
          "60 min = 1 uur → 7u60 = 8 uur precies"
        ],
        "distractorExplanations": {
          "0": "Goed! Ochtend: 4 uur 15 min + Middag: 3 uur 45 min = 7 uur 60 min = 8 uur.",
          "1": "Je hebt waarschijnlijk een rekenfout gemaakt bij de minuten. 4u15 + 3u45 = 7u60 minuten. 60 minuten = precies 1 uur, dus 7u60 = 8u00, niet 8u30.",
          "2": "Je bent de minuten vergeten om te zetten. 4u15 + 3u45 = 7u60 minuten. 60 minuten = 1 uur, dus 7u60 = 8u00, niet 7u30.",
          "3": "Je hebt waarschijnlijk de pauze (12:30 tot 13:15 = 45 minuten) meegeteld als werktijd. Maar de pauze telt niet mee. Bereken alleen de twee shifts: 4u15 + 3u45 = 8u00."
        }
      }
    },
    {
      "id": "TIJD-SAMENGESTELD-005",
      "familyId": "TIJD-SAMENGESTELD",
      "module": "Tijd",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_samengesteld",
      "questionType": "fill_in",
      "question": "Een voetbalwedstrijd begint om 15:30. De eerste helft duurt 45 minuten, de rust duurt 15 minuten en de tweede helft duurt ook 45 minuten. Hoe laat is de wedstrijd afgelopen? Typ in 24-uursnotatie (bijv. 14:00).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["17:15"],
        "caseSensitive": false,
        "placeholder": "??:??"
      },
      "conceptId": "time_multiple_periods",
      "variantIndex": 5,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.72,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": {
            "title": "Meerdere tijden optellen",
            "content": "Tel alle onderdelen op: 45 + 15 + 45 = 105 minuten = 1 uur 45 min. Begintijd 15:30 + 1 uur 45 min: 15:30 + 1 uur = 16:30, dan + 45 min = 17:15.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De wedstrijd heeft drie onderdelen: eerste helft (45 min), rust (15 min) en tweede helft (45 min). Totale duur: 45 + 15 + 45 = 105 minuten = 1 uur en 45 minuten. Nu tel je dit op bij de begintijd: 15:30 + 1 uur = 16:30. Dan + 45 minuten: 30 + 45 = 75 minuten = 1 uur 15 min. Dus: 16:30 + 45 min = 17:15. Controleer: van 15:30 tot 17:15 = 1 uur 45 min ✓.",
        "solutionSteps": [
          "Tel de onderdelen op: 45 + 15 + 45 = 105 minuten",
          "105 min = 1 uur 45 min",
          "15:30 + 1 uur = 16:30",
          "16:30 + 45 min = 17:15"
        ]
      }
    }
  ]
}